var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionDialog',{attrs:{"body-text":_vm.$t('modal.body.confirmCancelEntity', {
      entity: _vm.$tc('entities.shiftSwap', 1),
    }),"bubble-icon":{
    icon: _vm.Icon.TrashCan,
    colour: 'red',
  },"header":_vm.$t('modal.heading.cancelShiftSwap'),"max-width":400,"primary-button":{
    label: _vm.$t('button.confirmCancelShiftSwap'),
    action: () => _vm.confirm(),
    colour: 'red',
  },"secondary-action":{
    label: _vm.$t('button.cancel'),
    action: () => _vm.cancel(),
    colour: 'transparent',
  },"value":_vm.open,"persistent":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }